import AccountInfo from "./Account";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faWallet,
  faArrowCircleUp,
  faCoins,
  faHeart,
} from "@fortawesome/free-solid-svg-icons";
const Wallet = ({royalties, showEdit}) => {
  console.log(showEdit)
    const { balance, accountInfo, toThreshold, totalEarnings, totalPayments }=royalties
  return (
    <>
      <div className="grid md:grid-cols-2 gap-6 mb-8">
        {/* Wallet Overview */}
        <div className="bg-white rounded-2xl shadow-md p-6 text-gray-900">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-bold text-yellow-600 flex items-center gap-2">
            <FontAwesomeIcon icon={faWallet} /> Royalties Balance
            </h2>
            <span className="text-2xl font-bold text-green-600">
              ₦{balance}
            </span>
          </div>
          <p className="text-sm text-gray-600">
            This is your current royalties balance.
          </p>
        </div>
        <AccountInfo accountInfo={accountInfo} showEdit={showEdit}/>
      </div>

      {/* Quick Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
        <div className="bg-white rounded-xl p-4 flex flex-col items-center text-center text-gray-900 shadow">
          <FontAwesomeIcon
            icon={faCoins}
            className="text-yellow-600 text-3xl mb-2"
          />
          <h3 className="font-semibold text-lg">Total Royalties</h3>
          <p className="text-yellow-600 text-xl font-bold">
            ₦{totalEarnings}
          </p>
        </div>
        <div className="bg-white rounded-xl p-4 flex flex-col items-center text-center text-gray-900 shadow">
          <FontAwesomeIcon
            icon={faArrowCircleUp}
            className="text-red-500 text-3xl mb-2"
          />
          <h3 className="font-semibold text-lg">Total Withdrawals</h3>
          <p className="text-red-500 text-xl font-bold">
            ₦{totalPayments}
          </p>
        </div>
        <div className="bg-white rounded-xl p-4 flex flex-col items-center text-center text-gray-900 shadow">
          <FontAwesomeIcon
            icon={faHeart}
            className="text-pink-500 text-3xl mb-2"
          />
          <h3 className="font-semibold text-lg">To Threshold</h3>
          <p className="text-pink-600 text-xl font-bold">₦{toThreshold}</p>
        </div>
      </div>
    </>
  );
};
export default Wallet;
